const scrollBarWidth = () => {
  const propertyName = '--site-scrollbar-width';

  const setScrollbarWidth = () => {
    const width = window.innerWidth - document.body.offsetWidth;
    document.documentElement.style.setProperty(propertyName, `${width}px`);
  };
  setScrollbarWidth();
  window.addEventListener('resize', setScrollbarWidth);
};

export default scrollBarWidth();
